import * as React from 'react'

export function PaymentAllocationMath({
  payment,
  allocated,
  accountCredit,
  accountCreditCents,
}: {
  payment: string
  allocated: string
  accountCredit: string
  accountCreditCents: number
}) {
  return (
    <div
      data-testid="payment-allocation-math"
      className="space-y-0.5 rounded-md bg-muted/40 px-3 py-1.5 text-body-sm tabular-nums"
    >
      <MathRow label="Payment" amount={payment} />
      <MathRow label="Allocated" amount={allocated} />
      <MathRow
        label="To Account Credit"
        amount={accountCredit}
        emphasized={accountCreditCents !== 0}
      />
    </div>
  )
}

function MathRow({
  label,
  amount,
  emphasized = false,
}: {
  label: string
  amount: string
  emphasized?: boolean
}) {
  return (
    <div className={`flex items-baseline gap-2 ${emphasized ? 'font-medium' : ''}`}>
      <span>{label}</span>
      <span>{amount}</span>
    </div>
  )
}
